class ProductFeatureGrid extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Check if in Shopify editor
    this.isInEditor = window.Shopify && window.Shopify.designMode;
    
    if (this.isInEditor) {
      this.initEditorFeatures();
    }
  }

  initEditorFeatures() {
    this.enableVisualHelpers = this.dataset.enableVisualHelpers === 'true';
    this.showLivePreview = this.dataset.showLivePreview === 'true';
    this.showBlockOutlines = this.dataset.showBlockOutlines === 'true';
    this.enableDragDropSorting = this.dataset.enableDragDropSorting === 'true';
    this.editorColorMode = this.dataset.editorColorMode || 'auto';
    
    // Apply editor-specific attributes to the main container
    this.setAttribute('data-enable-visual-helpers', this.enableVisualHelpers);
    this.setAttribute('data-show-live-preview', this.showLivePreview);
    this.setAttribute('data-show-block-outlines', this.showBlockOutlines);
    this.setAttribute('data-enable-drag-drop-sorting', this.enableDragDropSorting);
    this.setAttribute('data-editor-color-mode', this.editorColorMode);
    
    // Add feature indices for visual identification
    this.addFeatureIndices();
    
    // Listen for Shopify editor events
    this.listenForEditorEvents();
    
    // Apply editor color mode
    this.applyEditorColorMode();
    
    console.log('Product Feature Grid: Editor features initialized');
  }
  
  addFeatureIndices() {
    if (!this.showBlockOutlines) return;
    
    const features = this.querySelectorAll('.product-feature-grid__item');
    features.forEach((feature, index) => {
      feature.setAttribute('data-feature-index', index + 1);
    });
  }
  
  listenForEditorEvents() {
    // Section select/deselect events
    document.addEventListener('shopify:section:select', (event) => {
      if (event.target !== this) return;
      
      // Highlight the section when selected
      this.classList.add('section-selected');
    });
    
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.target !== this) return;
      
      this.classList.remove('section-selected');
    });
    
    // Handle live editing preview
    document.addEventListener('shopify:section:edit', (event) => {
      if (event.target !== this) return;
      
      if (this.showLivePreview) {
        this.classList.add('is-editing');
        
        // Remove the indicator after a delay
        setTimeout(() => {
          this.classList.remove('is-editing');
        }, 2000);
      }
    });
  }
  
  applyEditorColorMode() {
    if (this.editorColorMode === 'auto') {
      // Use system preference
      const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.setAttribute('data-editor-color-mode', prefersDarkMode ? 'dark' : 'light');
    }
  }
}

// Define the custom element
customElements.define('product-feature-grid', ProductFeatureGrid);

// Initialize any quick edit capability for text content
document.addEventListener('DOMContentLoaded', () => {
  const isInEditor = window.Shopify && window.Shopify.designMode;
  
  if (isInEditor) {
    const grids = document.querySelectorAll('.product-feature-grid');
    
    grids.forEach(grid => {
      if (grid.dataset.enableQuickEdit !== 'true') return;
      
      // Find editable elements
      const editableElements = grid.querySelectorAll('.product-feature-grid__feature-title, .product-feature-grid__feature-text');
      
      editableElements.forEach(element => {
        // Make element appear editable
        element.classList.add('quick-editable');
        
        // Add edit indicator
        element.setAttribute('data-quick-edit', 'Click to edit');
        
        // This is a simplified demonstration - in a real implementation,
        // this would need to integrate with Shopify's editor API
        element.addEventListener('click', () => {
          console.log('Quick edit mode activated. In a real implementation, this would trigger the Shopify inline editor.');
        });
      });
    });
  }
}); 